import React from "react";
import { t } from "ttag";

import { IProduct } from "../../../models/catalogue.interfaces";

export const BasketLineWarrantyInfo = (props: {
    product: IProduct;
}): React.ReactNode => {
    let warrantyText = props.product.attributes.warranty
        ? props.product.attributes.warranty.value
        : null;
    if (
        !warrantyText &&
        props.product.parent &&
        props.product.parent.attributes.warranty
    ) {
        warrantyText = props.product.parent.attributes.warranty.value;
    }
    if (!warrantyText) {
        return null;
    }
    return (
        <li key={"warranty"}>
            {/* TODO(i18n): Use t with interpolation to keep complete sentence together: t`Warranty: ${warrantyText}` or use jt for HTML formatting */}
            {t`Warranty:`} <strong>{`${warrantyText}`}</strong>
        </li>
    );
};
